module.exports = __webpack_public_path__ + "assets/92b4b016309d96171b55714b6662c14d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/bell.mp3
 ** module id = 299
 ** module chunks = 0
 **/